'use client'

/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/semi */

import {
  styled,
  Flex,
  Box,
  $fontWeightLight,
  $fontSize,
  $fontWeightBold,
  $fontWeightNormal
} from '@acko-tech/building-blocks.ui.common';

export const Circle = styled.span`
  width: 3px;
  height: 3px;
  background: #c4c4c4;
  border-radius: 50%;
  margin-left: 5px;
  margin-right: 5px;
  vertical-align: middle;
  display: inline-block;
`;

export const DateText = styled.span`
  font-size: ${$fontSize.xxs};
  color: rgba(0, 0, 0, 0.5);
  font-weight: ${$fontWeightNormal};

  @media screen and (min-width: 426px) {
    font-size: ${$fontSize.xs};
  }
`;

export const DateRootContainer = styled(Flex)`
  gap: 4px;
  align-items: center;
  @media only screen and (max-width: 768px) {
    align-items: flex-start;
    flex-direction: column;
    gap: 8px;
  }
`
export const SeparatorWrapper = styled.div`
  @media only screen and (max-width: 768px) {
    display: none;
  }
`

export const TocContainer = styled(Box)`
  width: 100%;
  margin-bottom: 15px;
  margin-top: 15px;
  /* padding: 0 20px; */
  box-sizing: border-box;
  color: #2871ea;

  & > p {
    color: #2871ea !important;
  }

  & > ul {
    padding: 10px 10px 0 10px;
  }

  @media (min-width: 1141px) {
    margin-left: auto;
    margin-right: auto;
    padding: 0;
    // display: none;
  }
`;

export const Ul = styled.ul`
  list-style-type: ${(props) => (props.listStyleTypeNone ? 'none' : '')};
  font-weight: ${$fontWeightLight};
  font-size: ${$fontSize.xxs};

  & li {
    margin: 8px 0;
    color: #2871ea;
  }

  & > li > span {
    padding-right: 10px;
  }
  & ul {
    margin-left: 30px;
  }

  @media screen and (min-width: 426px) {
    font-size: ${$fontSize.xs};
  }
`;

export const CollapsibleHeader = styled(Flex)`
  font-weight: ${$fontWeightBold};
  font-size: ${$fontSize.normal};

  & > p {
    color: #2871ea !important;
  }
  
  justify-content: space-between;
  border-bottom: 1px solid #d6d9e0;
  padding-bottom: 20px;
  cursor: pointer;

  & img.open {
    transform: rotate(0deg);
    fill: #2871ea;
  }

  & img.close {
    transform: rotate(180deg);
    fill: #2871ea;
  }

  @media screen and (min-width: 426px) {
    font-size: ${$fontSize.small};
  }
`;
